import common from "commons/languages/english";

const trans = {
  program_name: "DS Commerce",
  version: "3.4.7",
};

export default { ...common, ...trans };
